module.exports = __webpack_public_path__ + "static/symposeum_logo-79ccb533e33767dbce5b190c8b132155.png";